import { useToast } from '@elva/ui';
import { getErrorMessage } from './errors';

export function useNotify() {
  const { toast } = useToast();
  return {
    success: (title: string, description?: string) =>
      toast({ title, ...(description ? { description } : {}), variant: 'success' }),
    error: (error: unknown, title = 'Action failed') =>
      toast({ title, description: getErrorMessage(error), variant: 'error' }),
    info: (title: string, description?: string) =>
      toast({ title, ...(description ? { description } : {}) }),
    warning: (title: string, description?: string) =>
      toast({ title, ...(description ? { description } : {}), variant: 'warning' }),
  };
}

export type Notifier = ReturnType<typeof useNotify>;
